import {
 
  ADD_FAVOURITE,ADD_FAVOURITE_FAIL,ADD_FAVOURITE_SUCCESS,
  GET_FAVOURITE,GET_FAVOURITE_FAIL,GET_FAVOURITE_SUCCESS
} from "./actionTypes"




export const addFavourite = (data, callback) => ({
  type: ADD_FAVOURITE,
  payload: {data, callback},
});


export const addFavouriteSuccess = (data) => ({
  type: ADD_FAVOURITE_SUCCESS,
  payload: data,
})

export const addFavouriteFail = (error) => ({
  type: ADD_FAVOURITE_FAIL,
  payload: error,
})
export const getFavourite = (data, callback) => ({
  type: GET_FAVOURITE,
  payload: {data, callback},
});


export const getFavouriteSuccess = (data) => ({
  type: GET_FAVOURITE_SUCCESS,
  payload: data,
})

export const getFavouriteFail = (error) => ({
  type: GET_FAVOURITE_FAIL,
  payload: error,
})


